/* eslint-disable custom-rules/no-direct-antd-message */
import { ChatMessage } from '@ant-design/pro-chat';
import './Message.less';
import CustomChatItem from '../ChatItem';
import { parseCopilotChatMessage } from '../../../services/copilotThread.service';
import {
  ContentObject,
  ContentObjectForReasoning,
  ContentObjectForSetupConfig,
  ContentObjectType,
} from '../../../interfaces/copilotChat';
import RecordMessage from './RecordMessage';
import SetUpConfigMessage from './SetUpConfigMessage';
import ErrorMessage from './ErrorMessage';
import ArtifactMessage from './ArtifactMessage';
import classNames from 'classnames';
import ReasoningMessage from './ReasoningMessage';
import TextMessage from '../../CopilotBase/TextMessage';

interface MessageProps {
  message: ChatMessage;
  handleArtifactClick: (artifact: ContentObject) => void;
}

const Message: React.FC<MessageProps> = ({ message, handleArtifactClick }) => {
  const renderResult = (msg: ChatMessage, result: ContentObject) => {
    if (result.type === ContentObjectType.SETUP && result.setupConfig) {
      return (
        <SetUpConfigMessage
          message={msg}
          result={result as ContentObjectForSetupConfig}
        />
      );
    }
    if (result.type === ContentObjectType.RECORD) {
      return <RecordMessage message={msg} result={result} />;
    }
    if (result.type === ContentObjectType.TOOL_CALL) {
      return (
        <ReasoningMessage
          message={msg}
          result={result as ContentObjectForReasoning}
        />
      );
    }

    return <ArtifactMessage result={result} onClick={handleArtifactClick} />;
  };

  const transformChatMessage = (msg: ChatMessage) => {
    const newMessage = parseCopilotChatMessage(msg);
    const result = newMessage;
    const index = 0;

    if (typeof result === 'object') {
      return (
        <div key={`${index}`} className="artifact-message-wrapper">
          {renderResult(msg, result)}
        </div>
      );
    } else {
      return (
        <div key={`${index}`} className="artifact-message-content">
          <CustomChatItem message={result as string} />
        </div>
      );
    }
  };

  return (
    <div
      className={classNames(
        'message-wrapper',
        message.extra?.isFollowUp && 'follow-up'
      )}
    >
      {message.error ? (
        <ErrorMessage message={message} />
      ) : (
        <TextMessage
          msg={message}
          editableContent={transformChatMessage(message)}
        />
      )}
    </div>
  );
};

export default Message;
